import React, { useState, useEffect } from 'react';
import { Card, Button, Alert, Space, Typography } from 'antd';
import axios from 'axios';

const { Title, Text } = Typography;

const AdminTest: React.FC = () => {
  const [testResults, setTestResults] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    const results: any = {};

    try {
      // 测试概览统计API
      const overviewResponse = await axios.get('http://localhost:8006/api/admin/stats/overview');
      results.overview = {
        success: true,
        data: overviewResponse.data
      };
    } catch (error) {
      results.overview = {
        success: false,
        error: error
      };
    }

    try {
      // 测试访客统计API
      const visitorsResponse = await axios.get('http://localhost:8006/api/admin/stats/visitors');
      results.visitors = {
        success: true,
        data: visitorsResponse.data
      };
    } catch (error) {
      results.visitors = {
        success: false,
        error: error
      };
    }

    try {
      // 测试数据提交API
      const submissionsResponse = await axios.get('http://localhost:8006/api/admin/stats/data-submissions');
      results.submissions = {
        success: true,
        data: submissionsResponse.data
      };
    } catch (error) {
      results.submissions = {
        success: false,
        error: error
      };
    }

    setTestResults(results);
    setLoading(false);
  };

  useEffect(() => {
    runTests();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <Title level={2}>Admin API 测试</Title>
      
      <Space direction="vertical" style={{ width: '100%' }}>
        <Button 
          type="primary" 
          onClick={runTests} 
          loading={loading}
        >
          重新运行测试
        </Button>

        <Card title="概览统计API测试">
          {testResults.overview ? (
            testResults.overview.success ? (
              <Alert
                message="✅ 概览统计API正常"
                description={`总访问量: ${testResults.overview.data.total_visits}, 总访客数: ${testResults.overview.data.total_visitors}`}
                type="success"
                showIcon
              />
            ) : (
              <Alert
                message="❌ 概览统计API失败"
                description={testResults.overview.error?.message || '未知错误'}
                type="error"
                showIcon
              />
            )
          ) : (
            <Text>等待测试结果...</Text>
          )}
        </Card>

        <Card title="访客统计API测试">
          {testResults.visitors ? (
            testResults.visitors.success ? (
              <Alert
                message="✅ 访客统计API正常"
                description={`访客数量: ${testResults.visitors.data.visitors?.length || 0}`}
                type="success"
                showIcon
              />
            ) : (
              <Alert
                message="❌ 访客统计API失败"
                description={testResults.visitors.error?.message || '未知错误'}
                type="error"
                showIcon
              />
            )
          ) : (
            <Text>等待测试结果...</Text>
          )}
        </Card>

        <Card title="数据提交API测试">
          {testResults.submissions ? (
            testResults.submissions.success ? (
              <Alert
                message="✅ 数据提交API正常"
                description={`数据提交数量: ${testResults.submissions.data.submissions?.length || 0}`}
                type="success"
                showIcon
              />
            ) : (
              <Alert
                message="❌ 数据提交API失败"
                description={testResults.submissions.error?.message || '未知错误'}
                type="error"
                showIcon
              />
            )
          ) : (
            <Text>等待测试结果...</Text>
          )}
        </Card>
      </Space>
    </div>
  );
};

export default AdminTest; 